import { addError } from 'rdx/alert';
import * as API from 'service/ErplyAPI/warehouses';

import * as types from './actionTypes';

export const fetchWarehouses = (params) => async (dispatch) => {
  dispatch({ type: types.FETCH_WAREHOUSES_START });
  try {
    const warehouses = await API.getWarehouses(params);
    dispatch({
      type: types.FETCH_WAREHOUSES_SUCCESS,
      payload: warehouses.records,
    });
  } catch (error) {
    dispatch(addError(error.message));
  }
};

export const saveWarehouse = (params) => async (dispatch) => {
  dispatch({ type: types.SAVE_WAREHOUSES_START });
  try {
    const result = await API.saveWarehouse(params);
    if (result.records.length) {
      dispatch(fetchWarehouses());
    } else {
      throw new Error('There was an error while creating the new location');
    }
  } catch (error) {
    dispatch(addError(error.message));
  }
};
